import "./SectionHeading.scss";

export type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
};

export const SectionHeading = ({ title, subtitle }: SectionHeadingProps) => {
  return (
    <div className="section-heading">
      <h1>{title}</h1>
      {subtitle && <h3>{subtitle}</h3>}
    </div>
  );
};
